export default __webpack_public_path__ + "static/media/AKAR.92d27251.webp";